import { render, staticRenderFns } from "./BuildingSectionList.vue?vue&type=template&id=2f29e840&scoped=true&"
import script from "./BuildingSectionList.vue?vue&type=script&lang=js&"
export * from "./BuildingSectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f29e840",
  null
  
)

export default component.exports